import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";



const ProtectedRoutes = () => {
  const location=useLocation()
 const token=useSelector(state=>state.auth.token);
  return token ? <Outlet /> :  
  <Navigate
    to={"/login"}
    state={{ from: location }} // <-- pass in route statereplace state={{ from: location }}
    replace
     />;
};
export default ProtectedRoutes